import React, { useEffect, useState } from 'react'
import {
    useLocation,
    useNavigate
} from "react-router-dom";

import { Header } from '../../components/Header'

export const Activate = () => {
    const history = useNavigate();
    const location = useLocation();

    const [hasErrors, setHasErrors] = useState(false);
    const [errorMessages, setErrorMessages] = useState('');

    function goSitters() {
        window.location.href = '/list';
    }

    function showDefaultError(){
        setErrorMessages('Ha ocurrido un error inesperado, por favor vuelva a intentarlo más tarde.')
        setHasErrors(true);
    }

    useEffect(() => {

        let params = new URLSearchParams(location.search);
        let token = params.get("token");

        if (!!token) {
            fetch(process.env.REACT_APP_API_URL + "/auth/activate", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(
                    {
                        token: token
                    })
            })
                .then((response) => {
                    if (response.ok) {
                        debugger;
                        response.json().then(data => {
                            debugger;
                            localStorage.setItem('kwt', data.token.auth_token);
                            setHasErrors(false);
                            history.push("/profile");
                        });
                    }
                    else {
                        if (response.status === 500) {
                            showDefaultError();
                        }
                        else {
                            response.json().then(data => {
                                data.errors.forEach((error) => {
                                    if (error === 'UserNotFound') {
                                        setErrorMessages('El enlace no es válido o ha caducado. Por favor contacte con el soporte a soporte@gamarreando.es')
                                        setHasErrors(true);
                                    }
                                    else {
                                        showDefaultError();
                                    }
                                })
                            });
                        }
                    }
                })
                .catch(function (error) {
                    showDefaultError();
                });
        }
        else {
            history.push("/");
        }
    }, []);

    return (
        <>
            <Header />
            <div id="sign-in-dialog" className="zoom-anim-dialog">
                <div>
                    <h2>Activando Usuario</h2>
                    <h4>Espere un momento por favor ....</h4>
                </div>
                <br />
                {hasErrors &&
                    <div className="notification error closeable">
                        <p>{errorMessages}</p>
                    </div>
                }
                <div className="col-md-12">
                    <button className="button" onClick={goSitters}>Buscar cuidadores</button>
                </div>
            </div>
        </>
    )
}